import moment from 'moment';
import { normalizeToFullYear } from './formatting';
import { IDate } from '../types';
import { ITag } from 'types';

export function getStringFromDate(dateInput: IDate | undefined): string {
  const { YYYY } = dateInput ?? {};
  let { DD, MM } = dateInput ?? {};
  if (DD && DD.length === 1) {
    DD = '0' + DD;
  }
  if (MM && MM.length === 1) {
    MM = '0' + MM;
  }
  if (YYYY && DD && MM) {
    return `${normalizeToFullYear(YYYY)}-${MM}-${DD}`;
  }
  return '';
}

export function getFormatDateFromObject(dateInput: IDate | undefined): string {
  const { YYYY, DD, MM } = dateInput ?? {};
  if (YYYY && DD && MM) {
    return `${DD}/${MM}/${normalizeToFullYear(YYYY)}`;
  }
  return '';
}

export function getFormatDateFromStoreDate(str: string | undefined): string {
  const date = getDateFromString(str);
  return getFormatDateFromObject(date);
}

export function getDateFromString(str: string | undefined): IDate {
  const date = moment(str, 'YYYY-MM-DD', true);
  if (date.isValid()) {
    const s = str?.split('-') ?? [];
    return {
      YYYY: s[0] || null,
      MM: s[1] || null,
      DD: s[2] || null
    };
  } else {
    return {
      YYYY: null,
      MM: null,
      DD: null
    };
  }
}

export function getDateFromObject(dateInput: IDate | undefined): Date | null {
  const { YYYY, DD, MM } = dateInput ?? {};
  if (YYYY && DD && MM) {
    return new Date(`${normalizeToFullYear(YYYY)}-${MM}-${DD}`);
  }
  return null;
}

export function isRemovableTag(tag: ITag) {
  return tag.removable === undefined || tag.removable === true;
}
